<template>
    <div class="row" id="amazing-slider-responsive">
        <div class="col-12">
            <div class="widget widget-product card">
                <header class="card-header">
                    <img src="/assets/img/amazing-slider/amazing-title-01.png" width="150px" alt="">
                    <!--<a href="#" class="view-all">مشاهده همه</a>-->
                </header>
                <div class="product-carousel owl-carousel owl-theme">
                    <div v-for="(amazingOffer,index) in amazingOffers" :class="!amazingOffer.IsAvailable ? 'filter item discount-box' : 'item discount-box'">
                        <span class="discount" v-if="amazingOffer.DiscountPercent != 0 && amazingOffer.Price != 0">{{amazingOffer.DiscountPercent}} %</span>
                        <router-link tag="a" :title="amazingOffer.ProductName" class="w-100 text-center" :to="{ name: 'product' , params: { productId: amazingOffer.ProductId , productName: amazingOffer.ProductName.replace(/\s+/g, '-') } }">
                            <img :src="amazingOffer.PicPath" @error="imageLoadOnError" class="img-fluid" :alt="amazingOffer.SchemaCode.replace(/\s+/g, '-') + ' ' +  amazingOffer.ProductName.replace(/\s+/g, '-')" :title="amazingOffer.ProductName.replace(/\s+/g, '-')">
                        </router-link>
                        <h2 class="post-title">
                            <router-link :title="amazingOffer.ProductName" :to="{ name: 'product' , params: { productId: amazingOffer.ProductId , productName: amazingOffer.ProductName.replace(/\s+/g, '-') }}">{{ amazingOffer.ProductName }}</router-link>
                        </h2>
                        <div class="price" v-if="amazingOffer.Price != 0">
                            <div v-if="amazingOffer.IsAvailable">
                                <del v-if="amazingOffer.DiscountPercent != 0"><span>{{ amazingOffer.Price | formatNumber }}<span>ریال</span></span></del>
                                <ins><span>{{ amazingOffer.FinalPrice | formatNumber }}<span>ریال</span></span></ins>
                            </div>
                            <div v-else>
                                <span class="unAvailable">ناموجود</span>
                            </div>
                        </div>
                        <div v-else>
                            <div class="callToMain">
                                <span class="call">جهت استعلام قیمت تماس بگیرید</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            amazingOffers: function () {
                return this.$store.getters.readAmazingOffers;
            }
        },
        methods: {
            imageLoadOnError(event) {
                event.target.src = "/assets/img/no-image-available.png";
            },
        }
    }
</script>
<style scoped>
    .discount-box {
        position: relative;
    }

        .discount-box .discount {
            content: '';
            width: 55px;
            height: 35px;
            background-color: #ef5662;
            color: #fff;
            top: 20px;
            left: 15px;
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            font-weight: bold;
            border-radius: 40px;
            z-index: 9999;
            font-size: 16px;
        }

    @media only screen and (min-width: 0px) and (max-width: 640px) {
        .discount-box .discount {
            width: 44px;
            height: 25px;
            top: 7px;
            left: 1px;
            font-size: 13px;
        }

        carousel .item .price del, .brand-slider .product-carousel .item .price del {
            font-size: 12px;
        }

        .widget-product .product-carousel .item .price del, .brand-slider .product-carousel .item .price del {
            color: #979898;
            font-size: 12px;
        }
    }
</style>